import { Controller } from "@hotwired/stimulus";
import { createFlow } from "@/controllers/flow";
import { InitializeTask, PlayButtonTask, StartGameTask } from "./play/flow_game_shared";
import { SPShowScreenTask, SPBackTask } from "./play/flow_game_sp";


/**
 * SP版（別画面）でのゲーム起動フローを実行する controller。
 *
 * - 初期化 → 再生ボタン待ち → ゲーム開始 → 画面表示 → 戻る動線
 */
export default class extends Controller {
  connect() {
    createFlow()
      // .debug()
      .flow(InitializeTask)
      .flow(PlayButtonTask)
      .flow(StartGameTask)
      .flow(SPShowScreenTask)
      .flow(SPBackTask)
      .run();
  }
}
